import React from 'react';
import {
  Alert,
  Box,
  Button,
  Typography,
  Chip,
  IconButton,
  Tooltip
} from '@mui/material';
import {
  AdminPanelSettings,
  Visibility,
  Logout,
  Info
} from '@mui/icons-material';

const ImpersonationBanner = ({ impersonatedClient, onStopImpersonation }) => {
  if (!impersonatedClient) return null;

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%'
        }
      }}
      action={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Tooltip title="View impersonation details">
            <IconButton size="small" color="inherit">
              <Info />
            </IconButton>
          </Tooltip>
          <Button
            size="small"
            variant="outlined"
            color="inherit"
            startIcon={<Visibility />}
            onClick={() => {
              // Show impersonation details in a dialog
              console.log('Impersonation details:', {
                client: impersonatedClient,
                timestamp: new Date().toISOString(),
                adminSession: localStorage.getItem('originalAdminData')
              });
            }}
          >
            Details
          </Button>
          <Button
            size="small"
            variant="contained"
            color="error"
            startIcon={<Logout />}
            onClick={onStopImpersonation}
          >
            Stop Impersonation
          </Button>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AdminPanelSettings />
          <Typography variant="body2" fontWeight="bold">
            Admin Impersonation Active
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Viewing as:
          </Typography>
          <Chip 
            label={impersonatedClient.name} 
            size="small" 
            color="primary"
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Plan:
          </Typography>
          <Chip 
            label={impersonatedClient.plan} 
            size="small" 
            color="secondary"
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Status:
          </Typography>
          <Chip 
            label={impersonatedClient.status} 
            size="small" 
            color={impersonatedClient.status === 'active' ? 'success' : 'warning'}
          />
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Risk:
          </Typography>
          <Chip 
            label={impersonatedClient.riskLevel} 
            size="small" 
            color={impersonatedClient.riskLevel === 'high' ? 'error' : 'success'}
          />
        </Box>
      </Box>
    </Alert>
  );
};

export default ImpersonationBanner;
